
document.querySelectorAll('[data-countdown]').forEach(element => {
    var date = element.getAttribute('data-countdown');
    var countDownDate = new Date(date).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();
    
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
    
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
        element.querySelector('.days').innerHTML = days;
        element.querySelector('.hours').innerHTML = hours;
        element.querySelector('.minutes').innerHTML = minutes;
        element.querySelector('.seconds').innerHTML = seconds;

        if (distance <= 60000) {
            element.querySelector('.seconds').parentElement.classList.add('pulse');
        }

        // Display the result in the element with id="demo"
        // element.innerHTML = days + "d " + hours + "h "
        // + minutes + "m " + seconds + "s ";
        // element.innerHTML = days + "d " + hours + "h "
        // + minutes + "m ";
    
        // If the count down is finished, write some text
        if (distance < 0) {
            document.getElementById("product-countdown").style.display = "none";
        }
    }, 1000);
});
